<template>
  <div class="reseller-list">
    <div class="title-box primary-box">
      <div class="title-box__back-container">
        <v-icon @click="$router.push('/')">mdi-chevron-left</v-icon>
      </div>
      <div class="title-box__title">
        <h2 itemprop="headline">{{getTranslation('reseller-list')}}</h2>
      </div>
    </div>
    <div class="reseller-list__container">
      <v-expansion-panels variant="popout" class="my-4" :rounded="false">
        <v-expansion-panel>
          <v-expansion-panel-title>
            <div class="reseller-list__item__title">
              <h3>Referente nazionale scientifico formativo/informativo</h3>
              <h3>Dott. Pierluigi Raffo</h3>
              <p>
                Esperto in masticazione e autore del primo libro sull'argomento:
                <strong>Evviva si mastica</strong>
              </p>
            </div>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div class="reseller-list__item__description_container">
              <div class="reseller-list__item__contacts">
                <h4>Contatti: </h4>
                <a :href="`tel:+393488337333`">Telefono: +39 348 833 7333</a>
              </div>
              <div class="reseller-list__item__activity-areas">
                <h4>Comuni di attività: </h4>
                <span>Tutta Italia</span>
              </div>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="reseller-list__filter">
      <v-text-field
      v-model="searchQuery"
      append-icon="mdi-magnify"
      clearable
      label="Cerca per citta, provincia, nome o attività"
      single-line
      hide-details
      @update:model-value="debouncedSearch"
      ></v-text-field>
    </div>
    <div class="reseller-list__container">
      <v-expansion-panels variant="popout" class="my-4" v-model="panels" :rounded="false">
        <v-expansion-panel v-for="reseller in filteredResellers" :key="reseller.id">
          <v-expansion-panel-title>
            <div class="reseller-list__item__title">
              <h3>({{ reseller.province }}) {{ reseller.city }}</h3>
              <p>{{ reseller.name }}</p>
              <h5>{{ reseller.title }}</h5>
            </div>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div class="reseller-list__item__description_container">
              <div class="reseller-list__item__contacts">
                <h4>Contatti: </h4>
                <a :href="`mailto:${reseller.email}`" v-if="reseller.email">Email: {{ reseller.email }}</a>
                <a :href="`tel:${reseller.phone}`" v-if="reseller.phone">Telefono: {{ reseller.phone }}</a>
              </div>
              <div class="reseller-list__item__activity-areas">
                <h4>Comuni di attività: </h4>
                <span>{{ reseller.activityCities }}</span>
              </div>
              <div class="reseller-list__item__description" v-if="reseller.description && reseller.description.length > 0">
                <h4>Cosa faccio: </h4>
                <div
                  class="md-text-container-reseller"
                  v-if="reseller.description"
                  v-html="reseller.description ?? ''"
                >
                </div>
              </div>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
import apiService from "@/services/ApiService";
import {getTranslation} from "@/services/stringTableService";
import _ from "lodash";

export default {
  name: 'ResellerList',
  data() {
    return {
      resellers: [],
      filteredResellers: [],
      searchQuery: "",
      language: "IT",
      panels: []
    }
  },
  methods: {
    getTranslation(key) {
      return getTranslation(this.language, key);
    },
    debouncedSearch: _.debounce(function() {
      if (!this.searchQuery || this.searchQuery.length === 0) {
        this.filteredResellers = this.resellers;
        return;
      }

      const filteredResellers = this.resellers.filter(reseller => {
      return reseller?.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        reseller?.city.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        reseller?.province.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        reseller?.activityCities.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        reseller?.title.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
      this.filteredResellers = filteredResellers;
    }, 300)
  },
  async beforeMount() {
    try {
      this.$store.dispatch('setLoading', false);
      let resellers = (await apiService.getResellers());

      resellers = resellers.sort((a, b) => {
          const nameA = a.province.toUpperCase();
          const nameB = b.province.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      this.resellers = resellers;
      this.filteredResellers = this.resellers;

    } catch (e) {
      console.error(e);
    } finally {
      this.$store.dispatch('setLoading', false);
    }
  }
}
</script>
<style scoped lang="scss">
@import "../style/_variables.scss";
.md-text-container-reseller {
  flex-direction: column;
  text-align: left;
  padding: 0px;
  gap: 10px;

  h2 {
    margin-top: 10px;
    font-family: $header-font;
  }
}
.reseller-list__item__title {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 5px;
}
.reseller-list {
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: $secondary-background-color;
  font-family: $header-font;
  .reseller-list__filter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    .v-text-field {
      width: 100%;
      max-width: 500px;
    }
  }
  .v-expansion-panels {
    width: 100%;
    max-width: 800px;
    .v-expansion-panel {
      width: 100%;
      .v-expansion-panel-title {
        width: 100%;
      }
      .v-expansion-panel-content {
        background-color: $background-color;
        color: $text-color;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }
  }
}
h4 {
  font-family: $header-font;
  color: $primary-color;
  font-size: 1.2rem;
  font-weight: bold;
}
.reseller-list__container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.reseller-list__item__description_container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;
}
.reseller-list__item__contacts {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: start;
}
.reseller-list__item__activity-areas {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: start;
}
.reseller-list__item__description {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
a {
  text-decoration: underline;
}
</style>